import React, {FC} from "react";
import Sticker from "../../../elements/sticker/Sticker";
import FlexLine from "../../../elements/flexLine/FlexLine";
import {TextType} from "../../../../types/baseType";
import ChartHeader from "../../../elements/chart/ChartHeader";
import Container from "../../../elements/container/Container";

interface EmptyProps {
    name: string,
    content: JSX.Element
    emptyTextBlock: JSX.Element
    className?: string
}

export const EmptyDashboard: FC<EmptyProps> = ({name, content, emptyTextBlock, className}) => {
    return <Sticker className={className}>
        <FlexLine textType={TextType.Header}>
            <ChartHeader>{name}</ChartHeader>
        </FlexLine>
        <Container>
            { content }
            { emptyTextBlock }
        </Container>
    </Sticker>
}